import { createContext, useContext } from "react";
import { DispatchAction,  RecruitState, ScheduleState, SelectedSession } from "../Common";
import { useImmerReducer } from "use-immer";


const RecruitInitialState:RecruitState={
    selectedSessions:[],
    currentState:ScheduleState.NONE,
    panelistOverAllStatus:"",
    clusterSelectionValidity:false,
    recruitError:false
}

function RecruitReducer(draft: RecruitState, action: DispatchAction) {
    switch (action.type) {
      case "BasicSessionSelection":
        let basicValue = [...action.value]
        basicValue.sort((left: SelectedSession, right: SelectedSession) => {

          let leftDate = new Date(`${left.sessionDay} ${left.sessionStartTime}`)
          let rightDate = new Date(`${right.sessionDay} ${right.sessionStartTime}`)
    
          if (leftDate < rightDate) {
            return -1;
          }
          else if (leftDate > rightDate) {
            return 1;
          }
          else {
            return 0
          }
        });
        draft.selectedSessions=basicValue;
        break;
      case "ClusterSessionSelection":
        let clusterValue = [...action.value]
        clusterValue.sort((left: SelectedSession, right: SelectedSession) => {

          let leftDate = new Date(`${left.sessionDay} ${left.sessionStartTime}`)
          let rightDate = new Date(`${right.sessionDay} ${right.sessionStartTime}`)
    
          if (leftDate < rightDate) {
            return -1;
          }
          else if (leftDate > rightDate) {
            return 1;
          }
          else {
            return 0
          }
        });
        draft.selectedSessions=clusterValue
        break;        
      case "ScheduleState":
        draft.currentState = action.value  
        break;
      case "PanelistStatus":
        draft.panelistOverAllStatus = action.value  
        break;            
      case "RecruitError":
        draft.recruitError = action.value  
        break;                       
      default:
        console.log("Unknown Action value:"+action.type)
        break;
    }
  }

const RecruitContext = createContext(RecruitInitialState);

const RecruitDispatchContext = createContext<React.Dispatch<DispatchAction>>(() => { });

export function RecruitContextProvider({ children }: any) {

    const [state, dispatch] = useImmerReducer(RecruitReducer, RecruitInitialState);

  
    return (
      <RecruitContext.Provider value={state}>
        <RecruitDispatchContext.Provider value={dispatch}>
          {children}
        </RecruitDispatchContext.Provider>
      </RecruitContext.Provider>
    );
  }
  
  export function useRecruitCtx() {
    return useContext(RecruitContext);
  }
  
  export function useRecruitDispatchCtx() {
    return useContext(RecruitDispatchContext);
  }
  
